/**
 * Exported Shopify Polaris inspired box shadows.
 * @see https://polaris.shopify.com/tokens/shadow
 */

export const boxShadows = {
  'brand-0': 'none',
  'brand-100': '0px 1px 0px 0px rgba(26, 26, 26, 0.07)',
  'brand-200': '0px 3px 1px -1px rgba(26, 26, 26, 0.07)',
  'brand-300': '0px 4px 6px -2px rgba(26, 26, 26, 0.20)',
  'brand-400': '0px 8px 16px -4px rgba(26, 26, 26, 0.22)',
  'brand-500': '0px 12px 20px -8px rgba(26, 26, 26, 0.24)',
  'brand-600': '0px 20px 20px -8px rgba(26, 26, 26, 0.28)',
  'brand-bevel-100':
    '1px 0px 0px 0px rgba(0, 0, 0, 0.13) inset, -1px 0px 0px 0px rgba(0, 0, 0, 0.13) inset, 0px -1px 0px 0px rgba(0, 0, 0, 0.17) inset, 0px 1px 0px 0px rgba(204, 204, 204, 0.5) inset',
  'brand-inset-100':
    '0px 1px 2px 0px rgba(26, 26, 26, 0.15) inset, 0px 1px 1px 0px rgba(26, 26, 26, 0.15) inset',
  'brand-inset-200':
    '0px 2px 1px 0px rgba(26, 26, 26, 0.20) inset, 1px 0px 1px 0px rgba(26, 26, 26, 0.12) inset, -1px 0px 1px 0px rgba(26, 26, 26, 0.12) inset',
  'brand-button-primary-success':
    '0px -1px 0px 1px rgba(12, 81, 50, 0.8) inset, 0px 0px 0px 1px rgba(19, 111, 69, 0.8) inset, 0px 0.5px 0px 1.5px rgba(255, 255, 255, 0.251) inset',
  'brand-button-primary-success-inset':
    '-1px 0px 1px 0px rgba(0, 0, 0, 0.2) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.2) inset, 0px 2px 0px 0px rgba(0, 0, 0, 0.6) inset',
  'brand-button-primary':
    '0rem -0.0625rem 0rem 0.0625rem rgb(36 82 182 / 80%) inset, 0rem 0rem 0rem 0.0625rem rgb(11 122 181 / 80%) inset, 0rem 0.03125rem 0rem 0.09375rem hsla(0, 0%, 100%, .349) inset',
  'brand-button-primary-active':
    '-0.0625rem 0rem 0.0625rem 0rem rgba(0,0,0,.2) inset,0.0625rem 0rem 0.0625rem 0rem rgba(0,0,0,.2) inset,0rem 0.125rem 0rem 0rem rgba(0,0,0,.6) inset',
  'brand-border-inset': '0px 0px 0px 1px rgba(0, 0, 0, 0.08) inset',
  'brand-button':
    '0rem -0.0625rem 0rem 0rem #b5b5b5 inset,0rem 0rem 0rem 0.0625rem rgba(0,0,0,.1) inset,0rem 0.03125rem 0rem 0.09375rem #fff inset',
  'brand-button-active':
    '-0.0625rem 0rem 0.0625rem 0rem rgba(26,26,26,.122) inset,0.0625rem 0rem 0.0625rem 0rem rgba(26,26,26,.122) inset,0rem 0.125rem 0.0625rem 0rem rgba(26,26,26,.2) inset',
  'brand-button-primary-critical':
    '0rem -0.0625rem 0rem 0.0625rem rgba(142,31,11,.8) inset,0rem 0rem 0rem 0.0625rem rgba(181,38,11,.8) inset,0rem 0.03125rem 0rem 0.09375rem hsla(0,0%,100%,.349) inset',
  'brand-button-primary-critical-inset':
    '-0.0625rem 0rem 0.0625rem 0rem rgba(0,0,0,.2) inset,0.0625rem 0rem 0.0625rem 0rem rgba(0,0,0,.2) inset,0rem 0.125rem 0rem 0rem rgba(0,0,0,.6) inset',

  'brand-button-caution':
    '0rem -0.0625rem 0rem 0.0625rem rgb(239 199 81 / 60%) inset, 0rem 0rem 0rem 0.0625rem rgb(245 212 99 / 70%) inset, 0rem 0.03125rem 0rem 0.09375rem hsla(0, 0%, 100%, .349) inset',
  'brand-button-caution-active':
    '-0.0625rem 0rem 0.0625rem 0rem rgba(133, 100, 4, .2) inset,0.0625rem 0rem 0.0625rem 0rem rgba(133, 100, 4, .2) inset,0rem 0.125rem 0rem 0rem rgba(133, 100, 4, .6) inset',
  'brand-button-magic':
    '0rem -0.0625rem 0rem 0.0625rem rgba(76,29,149,.8) inset,0rem 0rem 0rem 0.0625rem rgba(107,33,168,.8) inset,0rem 0.03125rem 0rem 0.09375rem hsla(0,0%,100%,.349) inset',
  'brand-button-magic-inset':
    '-0.0625rem 0rem 0.0625rem 0rem rgba(76,29,149,.2) inset,0.0625rem 0rem 0.0625rem 0rem rgba(76,29,149,.2) inset,0rem 0.125rem 0rem 0rem rgba(76,29,149,.6) inset',
  'brand-button-shadow-contrast':
    '0rem -0.0625rem 0rem 0.0625rem rgba(0,0,0,.8) inset,0rem 0rem 0rem 0.0625rem #303030 inset,0rem 0.03125rem 0rem 0.09375rem hsla(0,0%,100%,.25) inset',
  'brand-button-shadow-contrast-inset': '0rem 0.1875rem 0rem 0rem #000 inset',
};
